import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { NgxPermissionsGuard } from 'ngx-permissions';

import { environment } from '../environments/environment';

import { UserMeModel } from '@core/api';
import { PageNotFoundComponent } from '@ui/page-not-found';
import { MaintenanceComponent } from '@ui/maintenance/maintenance.component';
import { EmptyComponent } from '@core/components/components/empty-component/empty-component';
import { MaintenanceGuard } from '@core/guards/maintenance.guard';
import { RoleBasedRedirectGuard, UserCabinetGuard } from '@core/guards/roleBasedRedirect.guard';

const LOGIN_URL = environment.loginUrl;

const routes: Routes = [
  {
    path: 'maintenance',
    component: MaintenanceComponent
  },
  {
    path: 'cabinet',
    canActivate: [NgxPermissionsGuard, MaintenanceGuard, UserCabinetGuard],
    canActivateChild: [NgxPermissionsGuard, MaintenanceGuard, UserCabinetGuard],
    canLoad: [NgxPermissionsGuard, MaintenanceGuard, UserCabinetGuard],
    data: {
      /*permissions: {
        only: UserMeModel.RoleEnum.USER,
        redirectTo: LOGIN_URL
      }*/
    },
    loadChildren : '@accounts/user/user.module#UserModule'
  },
  {
    path: 'operator',
    canActivate: [NgxPermissionsGuard, MaintenanceGuard],
    canActivateChild: [NgxPermissionsGuard, MaintenanceGuard],
    canLoad: [NgxPermissionsGuard, MaintenanceGuard],
    data: {
      permissions: {
        only: UserMeModel.RoleEnum.OPERATOR,
        redirectTo: LOGIN_URL
      }
    },
    loadChildren : '@accounts/operator/operator.module#OperatorModule'
  },
  {
    path: 'admin',
    canActivate: [NgxPermissionsGuard, MaintenanceGuard],
    canActivateChild: [NgxPermissionsGuard, MaintenanceGuard],
    canLoad: [NgxPermissionsGuard, MaintenanceGuard],
    data: {
      permissions: {
        only: UserMeModel.RoleEnum.ADMIN,
        redirectTo: LOGIN_URL
      }
    },
    loadChildren : '@admin/admin.module#AdminModule'
  },
  {
    path: 'technical-operator',
    canActivate: [NgxPermissionsGuard, MaintenanceGuard],
    canActivateChild: [NgxPermissionsGuard, MaintenanceGuard],
    canLoad: [NgxPermissionsGuard, MaintenanceGuard],
    data: {
      permissions: {
        only: [
          UserMeModel.RoleEnum.TECHNICAL_OPERATOR,
          UserMeModel.RoleEnum.TECHNICAL_SUPPORT
        ],
        redirectTo: LOGIN_URL
      }
    },
    loadChildren : '@accounts/technical-operator/technical-operator.module#TechnicalOperatorModule'
  },
  {
    path: 'auth',
    canActivate: [MaintenanceGuard],
    canActivateChild: [MaintenanceGuard],
    loadChildren : '@core/auth/auth.module#AuthModule'
  },
  {
    path: '',
    component: EmptyComponent,
    canActivate: [RoleBasedRedirectGuard]
    //canActivate: [MaintenanceGuard],
    //loadChildren : '@accounts/user/user.module#UserModule'
  },
  {
    path: '404',
    component: PageNotFoundComponent
  },
  { path: '**', component: PageNotFoundComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {onSameUrlNavigation: 'reload'})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
